import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Droppable } from '../../../components/DndKit';
import { buildClass } from '../../../libs/classes';

const CmcSpacer = ({ droppableId }) => {
	useEffect(() => {
		console.log(`init CmcSpacer "${droppableId}"`);
	}, [droppableId]);

	return (
		<div className="cmc-spacer">
			<Droppable droppableId={droppableId} isDropDisabled={false} type="TILE">
				{(provided, snapshot) => (
					<div
						className={buildClass('cmc-droppable').add(snapshot.isDraggingOver, 'dragged-over')}
						ref={provided.innerRef}
						{...provided.droppableProps}
					>
						<div>{provided.placeholder}</div>
					</div>
				)}
			</Droppable>
		</div>
	);
};

CmcSpacer.propTypes = {
	// Droppable id
	droppableId: PropTypes.string.isRequired,
};

export default CmcSpacer;
